import { gridPath, type GridRect } from '../../lib/gridGeometry';

export function GridLines({
  rects,
  width,
  height,
  color,
  lineWidth,
}: {
  rects: readonly GridRect[];
  width: number;
  height: number;
  color: string;
  lineWidth: number;
}) {
  const path = gridPath(rects, width, height, lineWidth);
  if (!path || color === 'transparent') return null;
  return (
    <svg
      data-testid="timer-grid-lines"
      aria-hidden="true"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 20 }}
    >
      <path d={path} fill={color} fillRule="nonzero" />
    </svg>
  );
}
